<template>
  <div class="user">
    <div v-if="!selectedUser" class="no user-card">
      <span>{{ $t("SelectUser") }}</span>
    </div>
    <div v-if="!!selectedUser" class="user-info-container">
      <object-main-info :fields="fields" :identifier="user ? user.name : ''" :identifier-label="$t('')"
        :editing-data="editingData" :show-edit-button="actionToExecute !== 'addUser' && userHasPermission('user_update')" :card-label="$t(cardLabel)"
        :height="editingData ? '47%' : '29%'" :submit-button-label="submitButtonLabel"
        :required-fields-filled="requiredFieldsAreFilled" showEditActionButtons="false" @toggle-edit="toggleEdit"
        @update-object="updateUser" @save-object="saveObject" @cancel-edit="discardChangesDialogIsOpen = true">
        <template v-slot:object-image-slot>
          <img class="user-logo" :src="user ? user.image : null" alt="User Image Icon" />
        </template>

        <template v-slot:buttons-before-edit-slot>
          <custom-button v-if="actionToExecute !== 'addUser'" :icon="'mdi-lock'" :icon-size="13" :height="'20px'" :width="'20px'"
            :button-styling="buttonStyling" @buttonClick="toggleLock" />
        </template>

        <template v-slot:before-fields-slot v-if="editingData">
          <div class="edit-image-container">
            <input type="file" id="file" ref="file" @change="previewFile" accept="image/*" style="display: none" />
            <img class="user-logo" :src="user ? user.image : null" alt="User Image Icon" />
            <custom-button :height="'20px'" :label="$t('AddPhoto')"
              :button-styling="{ ...buttonStyling, 'padding': '0 5px', 'margin-right': '7px', 'font-size': '9px' }"
              @buttonClick="submitFile" />
            <custom-button :icon="'mdi-delete'" :icon-size="13" :width="'20px'" :height="'20px'"
              :button-styling="buttonStyling" @buttonClick="deleteUserImage" />
          </div>
        </template>
      </object-main-info>

      <user-specific-info  :selectedUser="selectedUser" :user="user" :key="updateSpecificInfoKey" :editing-data="editingData" :required-fields-filled="requiredFieldsAreFilled"
        :submit-button-label="submitButtonLabel" @update-required-field="specificRequiredFieldsAreFilled = $event"
        @cancel-edit="discardChangesDialogIsOpen = true" @save-user="saveChangesDialogIsOpen = true" ref="userSpecificInfo"/>
    </div>
    <loading-spinner :active.sync="loading" :is-full-page="false" color="#29BDF0" style="position: absolute;" />
    <dialog-choice :isOpen="saveChangesDialogIsOpen" :title="$t('SaveChanges')" :content="$t('SaveChangesContent')"
      :mainActionLabel="$t('Confirm')" @mainAction="saveObject" :secondaryActionLabel="$t('Cancel')"
      @secondaryAction="saveChangesDialogIsOpen = false" icon="mdi-content-save" iconColor="#29BDF0" />
    <dialog-choice :isOpen="discardChangesDialogIsOpen" :title="$t('DiscardChanges')"
      :content="$t('ClusterCreationConfirmation')" :mainActionLabel="$t('Confirm')" @mainAction="cancelEdit"
      :secondaryActionLabel="$t('Cancel')" @secondaryAction="discardChangesDialogIsOpen = false" icon="mdi-delete"
      iconColor="#29BDF0" />
    <dialog-choice :isOpen="tokenChangesDialogIsOpen" :title="$t('RevokeTokenMessage.RevokeToken')"
      :content="messageContentRevokeToken" :extraContent="messageExtraContentRevokeToken" :extraContentStyle="messageExtraContentStyling" :mainActionLabel="$t('Confirm')" @mainAction="revokeToken"
      :secondaryActionLabel="$t('Cancel')" @secondaryAction="cancelRevokeToken" icon="mdi-lock-open" iconColor="#29BDF0" />
  </div>
</template>


<script>
import { mapActions } from 'vuex';
import { bus } from "@/main.js";
import _ from 'lodash';
import utils from "@/utils";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import { createEditPageMixin } from "@/mixins/management/createEditPageMixin";
import LoadingSpinner from "vue-loading-overlay";
import ObjectMainInfo from '@/newComponents/_Organisms/ObjectMainInfo';
import UserSpecificInfo from '@/newComponents/Accounts/UserSpecificInfo.vue';
import DialogChoice from '@/newComponents/_Molecules/DialogChoice.vue';
import CustomButton from '@/newComponents/_Atoms/CustomButton';

export default {
  name: "User",

  components: {
    UserSpecificInfo,
    LoadingSpinner,
    DialogChoice,
    ObjectMainInfo,
    CustomButton,
  },

  mixins: [checkPermissionsMixin, objectManagementMixin, createEditPageMixin],

  props: {
    selectedUser: {
      type: Object,
    },

    activeTabUserType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      user: {
        password: null,
        password_confirmation: null
      },
      editingData: false,
      originalUser: {},
      specificRequiredFieldsAreFilled: false,
      updateSpecificInfoKey: 1,
      dataToSend: {},
      actionToExecute: 'UPDATE_SELECTED_User',
      submitButtonLabel: 'Save',
      cardLabel: 'EditUser',
      saveChangesDialogIsOpen: false,
      discardChangesDialogIsOpen: false,
      tokenChangesDialogIsOpen: false,
      passwordIsValid: false,
      buttonStyling: {
        'padding': '0px',
        'drop-shadow': '0.85px 0.85px 1.75px rgba(0, 0, 0, 0.25)',
        'border-radius': '4px',
      },

      topCardHeight: {
        style: {
          maxHeight: '50%',
          height: 'auto',
        },
      },
    }
  },


  mounted() {
    // this.getUsersOfDifferentTypes();
    bus.$on("update-roles-bus", (role) => {
      this.user.role = role
    });

    bus.$on("update-company-bus", (company) => {
      this.user.company = company;
      this.updateSpecificInfoKey++;
    });
  },

  destroyed() {
    bus.$off("update-roles-bus");
    bus.$off("update-company-bus");
  },

  watch: {
    selectedUser(value) {
      this.user = value;
      if (value !== null && Object.keys(value).length === 0) {
        this.setCreateUserVariables();
      } else if (!!value) {
        this.setEditUserVariables();
      } else if (value === null) {
        this.clearVariables();
      }
    },

    editingData() {
      bus.$emit("toggle-create-edit-flag")
    },
  },

  computed: {
    requiredFieldsAreFilled() {
      const necessaryUsers = !!this.user.first_name &&
        !!this.user.role.user_type &&
        !!this.user.email &&
        !!this.user.username &&
        !!this.user.role &&
        !!this.user.company &&
        (
          this.user.username.length >= 4 &&
          this.user.username.length <= 20
        ) &&
        Object.keys(this.user.role).length > 0 &&
        Object.keys(this.user.company).length > 0;

      if (this.actionToExecute === 'addUser') {
        this.passwordIsValid = (
          !!(this.user.password === this.user.password_confirmation) &&
          !!(this.user.password !== '' && this.user.password !== undefined)
        ) &&
        this.user.password.length >= 8 &&
        this.user.password_confirmation.length >= 8;

        return this.passwordIsValid && necessaryUsers
      } else {
        if (!!this.user.password) {
          this.passwordIsValid = (
            !!(this.user.password === this.user.password_confirmation) &&
            !!(this.user.password !== '' && this.user.password !== undefined)
          ) &&
          this.user.password.length >= 8 &&
          this.user.password_confirmation.length >= 8;

          return this.passwordIsValid && necessaryUsers
        }else{
          return necessaryUsers
        }
      }
    },

    creatingUser() {
      return this.actionToExecute === 'addUser';
    },

    defaultAvatarUser() {
      return require("@/assets/icon_new-user.png");
    },

    fields() {
      let fields = [];
      if (this.user !== null) {
        fields = [
          {
            icon: "person",
            label: this.$i18n.t("Username"),
            value: this.user.username,
            size: '100%',
            varName: 'username',
            inputType: 'text',
            disabled: false,
            required: true,
            validation: {
              validation: 'length',
              min: 4,
              max: 20
            }
          },
          {
            icon: "email",
            label: this.$i18n.t("Email"),
            value: this.user.email,
            size: '100%',
            varName: 'email',
            disabled: false,
            required: true,
            inputType: 'text',
            validation: {
              validation: 'email',
            }
          },
          {
            icon: "key",
            label: this.$i18n.t("TwoFactorAuthentication"),
            value: this.editingData
              ? this.user.has_two_factor_authentication ? 'True' : 'False'
              : this.user.has_two_factor_authentication ? this.$i18n.t('Yes') : this.$i18n.t('No'),
            size: '100%',
            disabled: this.editingData,
            required: true,
            inputType: 'radio',
            radioOptions: [{ value: 'True', label: this.$i18n.t('Yes') }, { value: 'False', label: this.$i18n.t('No') }],
            varName: 'has_two_factor_authentication',
            size: this.editingData ? '50%' : '100%',
          },
          {
            icon: "assignment_turned_in",
            label: this.$i18n.tc("Status"),
            value: this.editingData
              ? this.user.status ? 'True' : 'False'
              : this.user.status ? this.$i18n.t('Active') : this.$i18n.t('Inactive'),
            size: '100%',
            disabled: false,
            required: true,
            inputType: 'radio',
            radioOptions: [{ value: 'True', label: this.$i18n.t('Active') }, { value: 'False', label: this.$i18n.t('Inactive') }],
            varName: 'status',
            size: this.editingData ? '50%' : '100%',
          },
          // {
          //   icon: "manage_accounts",
          //   label: this.$i18n.tc("Role"),
          //   value: this.user.roles,
          //   size: '100%',
          //   disabled: false,
          //   inputType: 'text',
          //   varName: 'role',
          // },
          // {
          //   icon: "business",
          //   label: this.$i18n.tc("Company"),
          //   value: this.editingData ? null : this.user.company.name,
          //   size: '100%',
          //   disabled: true,
          //   inputType: 'text',
          //   varName: 'company',
          // },
        ];

        if (this.editingData) {
          fields.splice(0, 0, {
            label: this.$i18n.tc("FirstName"),
            value: this.user.first_name,
            disabled: false,
            required: true,
            inputType: 'text',
            varName: 'first_name',
            size: '50%',
            validation: {
              validation: 'length',
              min: 3,
              max: 40
            }
          },
          {
            label: this.$i18n.tc("LastName"),
            value: this.user.last_name,
            disabled: false,
            inputType: 'text',
            varName: 'last_name',
            size: '50%',
          },
          );
          fields.splice(7, 2);
          if (this.user.role.user_type === "mobile" || this.user.role.user_type === "mobile viewer") {
            fields.splice(7, 0, {
              label: this.$i18n.tc("Password"),
              value: this.user.password,
              disabled: false,
              required: true,
              inputType: 'password',
              varName: 'password',
              size: '50%',
              validation: {
                validation: 'password',
              }
            },
            {
              label: this.$i18n.tc("ConfirmPassword"),
              value: this.user.password_confirmation,
              disabled: false,
              required: true,
              inputType: 'password',
              varName: 'password_confirmation',
              size: '50%',
              validation: {
                validation: 'confirm_password',
                password_value: this.user.password,
              }
            },
            )
          }else{
            fields.splice(7, 0,
            {
              label: this.$i18n.tc("Password"),
              value: this.user.password,
              disabled: false,
              required: true,
              inputType: 'password',
              varName: 'password',
              size: '50%',
              validation: {
                validation: 'password',
              }
            },
            {
              label: this.$i18n.tc("ConfirmPassword"),
              value: this.user.password_confirmation,
              disabled: false,
              required: true,
              inputType: 'password',
              varName: 'password_confirmation',
              size: '50%',
              validation: {
                validation: 'confirm_password',
                password_value: this.user.password,
              }
            },
            )
          }

        }
      }
      return fields;
    },

    messageContentRevokeToken() {
      let name = this.selectedUser ? this.selectedUser.name : "";
      return (
        this.$i18n.t("RevokeTokenMessage.DoYouConfirm") +
        " " +
        name +
        this.$i18n.t("RevokeTokenMessage.TokenRevoke") +
        "?"
      );
    },

    messageExtraContentRevokeToken() {
      return(
        this.$i18n.t("RevokeTokenMessage.PleaseNoteRequestsRevoked") + "."
      )
    },

    messageExtraContentStyling(){
      return{
        'font-size': '0.7rem !important',
        'color': '#9592a5 !important',
        'line-height': '1.5 !important',
        'padding-top': '10px !important',
        'margin-left': '25px !important',
        'margin-right': '25px !important',
      }
    }

  },

  methods: {
    ...mapActions([
      "fetchUserByID",
      "revokeUserToken",
    ]),

    requiredFieldsValidation() {
      return true;
    },

    async getUserByID() {
      let id = this.selectedUser.id;
      let includes = this.getIncludes();

      this.loading = true;
      try {
        let user = await this.fetchUserByID({
          id: id,
          includes: includes
        });
        user.password = null;
        user.password_confirmation = null;
        // this.user = {  ...this.user, ...user }
        this.user = user;
        this.originalUser = _.cloneDeep(this.user);

      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    getIncludes() {
      let includes = "";
      includes += "company,";
      includes += "permissions,";
      includes += "roles,";
      includes += "workspaces";
      return includes;
    },

    updateUser(updatedValue) {
        this.user[updatedValue.varName] = updatedValue.value;
    },

    cancelEdit() {
      this.discardChangesDialogIsOpen = false;
      this.editingData = false;
      if (this.user.id) {
        this.user = _.cloneDeep(this.originalUser);
      } else {
        this.$emit('clear-selected-item');
      }
    },

    toggleEdit() {
      if (this.editingData) {
        this.discardChangesDialogIsOpen = true;
      } else {
        this.editingData = !this.editingData
      }
    },

    cancelRevokeToken() {
      this.tokenChangesDialogIsOpen = false;
    },

    toggleLock() {
      this.tokenChangesDialogIsOpen = true;
    },

    async revokeToken() {
      try {
        this.revokeTokenDialog = false;

        await this.revokeUserToken({ uuid: this.user.uuid });
        this.$toasted.global.toast_success(
          this.$i18n.t("RevokeTokenSuccessfully")
        );
      } catch (e) {
        console.error(e);
        this.$toasted.global.toast_error(this.$i18n.t("TokenNotRevoke"));
      } finally {
        this.cancelRevokeToken();
      }
    },

    async saveObject() {
      this.saveChangesDialogIsOpen = false;
      try {
        this.loading = true;

        this.createDataToSend();

        if (Object.keys(this.dataToSend).length > 0) {
          let data = this.dataToSend;
          if (!this.creatingUser) {
            this.dataToSend.uuid = this.user.uuid;
            data = {
              id: this.user.id,
              updatedData: this.dataToSend
            }
          }

          await this.$store.dispatch(this.actionToExecute, data);
        }

        this.editingData = false;

        if (!this.creatingUser) {
          this.getUserByID();
          this.$toasted.global.toast_success(this.$i18n.t('UserUpdatedSuccessfully'));
        } else {
          this.$toasted.global.toast_success(this.$i18n.t('UserCreatedSuccessfully'));
        }

        bus.$emit('reload-users');
      } catch (error) {
        console.error(error);
        this.handleError(error);
      } finally {
        this.loading = false;
        this.dataToSend = {};
      }
    },

    /** Fills the object to send to the server by putting a watcher in each variable of the object */
    createDataToSend() {
      Object.keys(this.user).forEach(key => {
        if (this.user[key] !== this.originalUser[key]) {
          this.dataToSend[key] = this.user[key];
        }
      });

      this.dataToSend.company_id = this.dataToSend.company.id

      this.dataToSend.role = this.dataToSend.role.id

      this.dataToSend.type = this.user.role.user_type;

      delete this.dataToSend.company;

      delete this.dataToSend.permissions;

      this.dataToSend.workspaces = this.dataToSend.workspaces.map(workspace => workspace.wp_id);

      if (!this.creatingUser) {
        if (this.user.company) {
          if (this.user.company.length > 0) {
            this.dataToSend.company = this.prepareListOfObjectsToSend(
              this.user.company
            );
          }
          //  else {
          //   this.dataToSend.company = [{ delete_all: true }];
          // }
        }

        // if (this.user.permissions) {
        //   if (this.user.permissions.length > 0) {
        //     this.dataToSend.permissions = this.prepareListOfIDsToSend(
        //       this.user.permissions
        //     );
        //   } else {
        //     this.dataToSend.permissions = [{ delete_all: true }];
        //   }
        // }


        if (this.dataToSend.password === "") {
          delete this.dataToSend.password;
        }

        if (this.dataToSend.passwordConfirmation === "") {
          delete this.dataToSend.passwordConfirmation;
        }

      }
    },

    handleError(error) {
      let errorHandle = utils.errorHandler(error);

      if (typeof errorHandle === "object") {
        if (errorHandle.hasOwnProperty("username")) {
          if (errorHandle.username[0].includes('regex')) {
          this.$toasted.global.toast_error(this.$i18n.t('UserRegex'));
          }
          if (errorHandle.username[0].includes('unique')) {
          this.$toasted.global.toast_error(this.$i18n.t('UserUnique'));
          }
        }
        if (errorHandle.hasOwnProperty("email")) {
          this.$toasted.global.toast_error(this.$i18n.t('ValidEmail'));
        }
        if (errorHandle.hasOwnProperty("password")) {
          this.$toasted.global.toast_error(this.$i18n.t('ValidPassword'));
        }
        if (errorHandle.hasOwnProperty("name")) {
          this.$toasted.global.toast_error(this.$i18n.t('ValidName'));
        }
      } else if (typeof errorHandle === "string") {
        this.$toasted.global.toast_error(errorHandle);
      }
    },

    setCreateUserVariables() {
      this.user = {
        first_name: null,
        last_name: null,
        email: null,
        status: true,
        username: undefined,
        password: undefined,
        password_confirmation: undefined,
        company: {},
        role: {},
        workspaces: [],
        image: this.defaultAvatarUser,
        permissions: [],
      };
      this.originalUser = {},
      this.actionToExecute = 'addUser';
      this.submitButtonLabel = 'Create';
      this.cardLabel = 'NewUser';
      this.editingData = true;
    },

    setEditUserVariables() {
      this.getUserByID();
      this.actionToExecute = 'editUserByID';
      this.submitButtonLabel = 'Save';
      this.cardLabel = 'EditUser';
    },

    clearVariables() {
      this.user = null;
      this.originalUser = null;
      this.editingData = false;
    },

    deleteUserImage() {
      this.updateUser({ varName: 'image', value: this.defaultAvatarUser });
    },

    /**
       * Initiates the process of submitting an image file.
       */
    submitFile() {
      this.$refs.file.click();
    },

    /**
     * Initiates the process of preview aof the submitted image file.
     */
    previewFile() {
      this.$emit("imageValidation", false);
      let file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      this.createPreview(file);
    },

    /**
     * Obtains a readable image from the file submitted.
     * @param file
     */
    createPreview(file) {
      let reader = new FileReader();

      reader.onload = e => {
        this.updateUser({ varName: 'image', value: e.target.result });
      };
      reader.readAsDataURL(file);
    },

  },
}
</script>

<style scoped>
.user {
  height: 100%;
  max-height: 100%;
  background-color: #fff;
  position: relative;
  border-radius: 8px;
}

.user-card {
  height: 100%;
}

.user-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

.no.user-card {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.no.user-card>span {
  color: #29BDF0;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
}

.user-info-container {
  gap: 8px;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
}

.user-logo {
  background-color: white;
  border-radius: 8px;
  height: 40px;
  width: 40px;
  box-shadow: 1.75px 1.75px 4.75px 0px rgba(0, 0, 0, 0.25);
  margin-right: 16px;
  margin-left: 2px;
}

.edit-image-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/Accounts/User.vue